export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_FOUND = "GET_USER_FOUND";
export const GET_USER_NOT_FOUND = "GET_USER_NOT_FOUND";

export const TOKEN_REFRESHED = "TOKEN_REFRESHED";

export const TELEGRAM_SIGNIN_REQUEST = "TELEGRAM_SIGNIN_REQUEST";
export const TELEGRAM_SIGNIN_SUCCESS = "TELEGRAM_SIGNIN_SUCCESS";
export const TELEGRAM_SIGNIN_FAILED = "TELEGRAM_SIGNIN_FAILED";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const UPDATE_USER_AFTER_SETTING_REQUEST =
	"UPDATE_USER_AFTER_SETTING_REQUEST";
export const UPDATE_USER_AFTER_SETTING_SUCCESS =
	"UPDATE_USER_AFTER_SETTING_SUCCESS";
export const UPDATE_USER_AFTER_SETTING_ERROR =
	"UPDATE_USER_AFTER_SETTING_ERROR";


export const FETCH_BALANCE_REQUEST = "FETCH_BALANCE_REQUEST";
export const FETCH_BALANCE_SUCCESS = "FETCH_BALANCE_SUCCESS";
export const FETCH_BALANCE_FAILED = "FETCH_BALANCE_FAILED";

export const CONNECT_REQUEST = "CONNECT_REQUEST";
export const CONNECT_SUCCESS = "CONNECT_SUCCESS";
export const CONNECT_FAILED = "CONNECT_FAILED"; 

// Silent Login Actions
export const SILENT_LOGIN_REQUEST = "SILENT_LOGIN_REQUEST";
export const SILENT_LOGIN_SUCCESS = "SILENT_LOGIN_SUCCESS";
export const SILENT_LOGIN_FAILED = "SILENT_LOGIN_FAILED";

// Connect Account Actions (Upgrade Silent Login to Connected Account)
export const CONNECT_ACCOUNT_REQUEST = "CONNECT_ACCOUNT_REQUEST";
export const CONNECT_ACCOUNT_SUCCESS = "CONNECT_ACCOUNT_SUCCESS";
export const CONNECT_ACCOUNT_FAILED = "CONNECT_ACCOUNT_FAILED";

export const LoginAction = (data) => {
	return { type: GET_USER_REQUEST, payload: data };
};

export const LogoutAction = (successcallback) => {
	return { type: LOGOUT, successcallback: successcallback };
};

export const UpdateUserAuthAction = (data) => {
	return { type: UPDATE_USER_AFTER_SETTING_SUCCESS, payload: data };
};

export const fetchBalanceAuthAction = () => {
	return { type: FETCH_BALANCE_REQUEST };
};
 
export const ConnectAction = (data,callback) => {
	return { type: CONNECT_REQUEST, payload: data,successCallback:callback };
};

export const TelegramSignInAction = (data) => {
	return { type: TELEGRAM_SIGNIN_REQUEST,payload: data };
};

/**
 * Silent Login Action
 * Performs automatic device-based login without requiring user credentials
 * @param {Object} data - Contains deviceId and other device info
 * @param {Function} callback - Optional success callback
 */
export const SilentLoginAction = (data, callback) => {
	return { type: SILENT_LOGIN_REQUEST, payload: data, successCallback: callback };
};

/**
 * Connect Account Action
 * Upgrades a silent login user to a connected account (Google/Discord)
 * Merges existing silent login data with the connected account
 * @param {Object} data - Contains social login info (email, name, verifier, etc.)
 * @param {Function} callback - Optional success callback
 */
export const ConnectAccountAction = (data, callback) => {
	return { type: CONNECT_ACCOUNT_REQUEST, payload: data, successCallback: callback };
};